import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import AllUsersCard from './AllUsersCard';
import DelinquencyReportCard from './DelinquencyReportCard';
import HrReports from './HrReports';
import UserHourlyCostList from './UserHourlyCostList';
import UserTaskTotalsCardContainer from './UserTaskTotalsCardContainer';
import Page from '../../common/components/Page';
import TimeOffPage from './time-off-balances/TimeOffPage';

const HumanResourcesPage = () => {
  return (
    <Page full>
      <Switch>
        <Route exact path="/human-resources/employee-cost" render={() => <UserHourlyCostList />} />
        <Route exact path="/human-resources/reports" render={() => <HrReports />} />
        <Route exact path="/human-resources/reports/all-users" render={() => <AllUsersCard />} />
        <Route exact path="/human-resources/time-off" render={() => <Redirect to="/human-resources/time-off/balances" />} />
        <Route exact path="/human-resources/time-off/balances" render={() => <TimeOffPage />} />
        <Route exact path="/human-resources/time-off/settings" render={() => <TimeOffPage />} />
        <Route exact path="/human-resources/time-off/rollover" render={() => <TimeOffPage />} />
        {/* Legacy routes - redirect to new consolidated page */}
        <Route exact path="/human-resources/time-off-balances" render={() => <Redirect to="/human-resources/time-off/balances" />} />
        <Route exact path="/human-resources/time-off-settings" render={() => <Redirect to="/human-resources/time-off/settings" />} />
        <Route exact path="/human-resources/year-end-rollover" render={() => <Redirect to="/human-resources/time-off/rollover" />} />
        <Route
          exact
          path="/human-resources/reports/delinquency"
          render={() => <DelinquencyReportCard />}
        />
        <Route
          path="/human-resources/reports/user-task-totals"
          render={() => <UserTaskTotalsCardContainer />}
        />
      </Switch>
    </Page>
  );
};

export default HumanResourcesPage;
